import type { TrainingProfile } from '../schema/profile';
import { asbestosAwarenessProfile } from './asbestos-awareness';
import { chainsawProfile } from './chainsaw';
import { confinedSpaceProfile } from './confined-space';
import { constructionSiteProfile } from './construction-site';
import { driversReferentsProfile } from './drivers-referents';
import { fGasesProfile } from './f-gases';
import { fireProtectionProfile } from './fire-protection';
import { firstAidProfile } from './first-aid';
import { gasAppliancesProfile } from './gas-appliances';
import { generalBozpProfile } from './general-bozp';
import { hazardousChemicalsProfile } from './hazardous-chemicals';
import { hotWorksBitumenProfile } from './hot-works-bitumen';
import { laddersScaffoldingProfile } from './ladders-scaffolding';
import { liveElectricalProfile } from './live-electrical';
import { loneWorkingProfile } from './lone-working';
import { manualHandlingProfile } from './manual-handling';
import { powerToolsProfile } from './power-tools';
import { pressureVesselsAwarenessProfile } from './pressure-vessels-awareness';
import { weldingProfile } from './welding';
import { workAtHeightsProfile } from './work-at-heights';

/** All authored training profiles, keyed by slug. The seeder iterates this. */
export const PROFILES: Record<string, TrainingProfile> = {
  [workAtHeightsProfile.slug]: workAtHeightsProfile,
  [generalBozpProfile.slug]: generalBozpProfile,
  [liveElectricalProfile.slug]: liveElectricalProfile,
  [gasAppliancesProfile.slug]: gasAppliancesProfile,
  [confinedSpaceProfile.slug]: confinedSpaceProfile,
  [hazardousChemicalsProfile.slug]: hazardousChemicalsProfile,
  [manualHandlingProfile.slug]: manualHandlingProfile,
  [weldingProfile.slug]: weldingProfile,
  [fireProtectionProfile.slug]: fireProtectionProfile,
  [firstAidProfile.slug]: firstAidProfile,
  [driversReferentsProfile.slug]: driversReferentsProfile,
  [constructionSiteProfile.slug]: constructionSiteProfile,
  [powerToolsProfile.slug]: powerToolsProfile,
  [laddersScaffoldingProfile.slug]: laddersScaffoldingProfile,
  [chainsawProfile.slug]: chainsawProfile,
  [asbestosAwarenessProfile.slug]: asbestosAwarenessProfile,
  [loneWorkingProfile.slug]: loneWorkingProfile,
  [fGasesProfile.slug]: fGasesProfile,
  [hotWorksBitumenProfile.slug]: hotWorksBitumenProfile,
  [pressureVesselsAwarenessProfile.slug]: pressureVesselsAwarenessProfile,
};

export function getProfile(slug: string): TrainingProfile | undefined {
  return PROFILES[slug];
}
